// Copyright 2024 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
// material ui
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';

import { ClassesOverrides } from './list';

const defaultClasses = { icon: '', wrapper: '' };
export const DetailsIndicator = ({ classes = defaultClasses }: ClassesOverrides) => {
  const { icon = '', wrapper = '' } = classes;
  return (
    <div className={`bold flexbox center-aligned link-color nowrap ${wrapper}`}>
      View details
      <ArrowForwardIcon className={`margin-left-xsmall ${icon}`} fontSize="small" />
    </div>
  );
};

export default DetailsIndicator;
